/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// window.addEventListener('load', function () {
//   const myTimeout = setTimeout(myGreeting, 3500);

//   function myGreeting() {
//     let productInfoHeight = document.querySelector('.product-block-list__item.product-block-list__item--info .card').clientHeight;
  
//     let spacingBullets = `calc(${productInfoHeight}px + 50px)`;
//     document.getElementById('product-bullets').style.marginTop='unset';
//     document.getElementById('product-bullets').style.top=spacingBullets;
//   }
// }, false);

window.addEventListener('load', function () {
   // Get all the paragraphs
    var paragraphs = document.querySelector('.blog-container p');

    // Get the hidden section
    var hiddenSection = document.getElementById('hidden-section');

  // console.log(paragraphs.nextSibling.nextSibling.nextSibling);
  // Legacy Neep #hidden-section insertion — superseded by the Promotional Ads mid-blog system.
  // Guarded with a hiddenSection null-check so it is inert when #hidden-section is absent.
  if(paragraphs && hiddenSection) {
        paragraphs.parentNode.insertBefore(hiddenSection, paragraphs.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling.nextSibling);
    hiddenSection.style.display = 'block';
  }

}, false);
      $( "#extended-warranty, .modal__inner #extended-warranty" ).on( "change", function(event) {
        var checkbox = $('#extended-warranty');
        var additionalProductVariantId = '42381026984151';
        console.log(checkbox);
        if (checkbox.prop('checked')) {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    quantity: 1,
                    id: additionalProductVariantId
                },
                dataType: 'json',
                success: function(response) {
                    // Redirect to the cart or update cart summary
                  console.log(response);
                    
                }
            });
        }else {
          $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    quantity: 0,
                    id: additionalProductVariantId
                },
                dataType: 'json',
                success: function(response) {
                    // Redirect to the cart or update cart summary
                  console.log(response);
                    
                }
            });
        }
        
        // Submit the main product form
        // $(this)[0].submit();
    });

// ### Request qoute button actions ###//
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-request-quote');
    if (!btn) return;

    if (
      window.LiveChatWidget &&
      typeof window.LiveChatWidget.call === 'function'
    ) {
      e.preventDefault();
      window.LiveChatWidget.call('maximize');
    }
  });
});